// The server preview's sample data (internal/httpapi/template_preview.go samplePreviewPage).
const SAMPLES: Record<string, string> = {
  "member.full_name": "Sample Member",
  "member.email": "member@example.org",
  "member.membership_no": "SAMPLE-00001",
  "certificate.membership_no": "SAMPLE-00001",
  "certificate.doc_control_id": "CIPM/PREVIEW/0000/000000",
  "certificate.verify_token": "preview-not-a-real-certificate",
  "certificate.verify_url": "https://verify.example/v/preview",
  "certificate.verification_code": "PREV-IEW0-CODE",
  "program.name": "Sample Induction",
};

/** The text a bind shows on the canvas; program.type is the template's certificate type, as in the preview. */
export function sampleText(bind: string | undefined, opts: { certType: string; now: Date; format?: string }): string {
  if (!bind) return "{no bind}";
  if (bind === "program.type") return opts.certType;
  if (bind === "certificate.issued_at") return goFormat(opts.now, opts.format || "2006-01-02");
  return SAMPLES[bind] ?? `{${bind}}`;
}

const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
const DAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
const pad = (n: number, width = 2, fill = "0") => String(n).padStart(width, fill);

// Longest first where one chunk starts another, as Go's nextStdChunk matches them.
const CHUNKS: [string, (d: Date) => string][] = [
  ["January", (d) => MONTHS[d.getUTCMonth()] ?? ""],
  ["Jan", (d) => (MONTHS[d.getUTCMonth()] ?? "").slice(0, 3)],
  ["Monday", (d) => DAYS[d.getUTCDay()] ?? ""],
  ["Mon", (d) => (DAYS[d.getUTCDay()] ?? "").slice(0, 3)],
  ["MST", () => "UTC"],
  ["2006", (d) => String(d.getUTCFullYear())],
  ["002", (d) => pad(dayOfYear(d), 3)],
  ["01", (d) => pad(d.getUTCMonth() + 1)],
  ["02", (d) => pad(d.getUTCDate())],
  ["03", (d) => pad(hour12(d))],
  ["04", (d) => pad(d.getUTCMinutes())],
  ["05", (d) => pad(d.getUTCSeconds())],
  ["06", (d) => pad(d.getUTCFullYear() % 100)],
  ["15", (d) => pad(d.getUTCHours())],
  ["1", (d) => String(d.getUTCMonth() + 1)],
  ["_2", (d) => pad(d.getUTCDate(), 2, " ")],
  ["2", (d) => String(d.getUTCDate())],
  ["3", (d) => String(hour12(d))],
  ["4", (d) => String(d.getUTCMinutes())],
  ["5", (d) => String(d.getUTCSeconds())],
  ["PM", (d) => (d.getUTCHours() >= 12 ? "PM" : "AM")],
  ["pm", (d) => (d.getUTCHours() >= 12 ? "pm" : "am")],
  ["Z07:00", () => "Z"],
  ["-07:00", () => "+00:00"],
  ["-0700", () => "+0000"],
  ["-07", () => "+00"],
];

const hour12 = (d: Date) => d.getUTCHours() % 12 || 12;
const dayOfYear = (d: Date) => Math.floor((Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()) - Date.UTC(d.getUTCFullYear(), 0, 1)) / 86400000) + 1;

/** Formats a time in UTC with a Go layout, covering the date and time chunks a certificate uses. */
export function goFormat(date: Date, layout: string): string {
  let out = "";
  let i = 0;
  while (i < layout.length) {
    const chunk = CHUNKS.find(([token]) => layout.startsWith(token, i));
    if (chunk) {
      out += chunk[1](date);
      i += chunk[0].length;
    } else {
      out += layout[i];
      i++;
    }
  }
  return out;
}
